import _ from "lodash";
import PropTypes from "prop-types";
import React from "react";
import ImmutablePropTypes from "react-immutable-proptypes";
import { connect } from "react-redux";

import FormDropdown from "../../../components/form/FormDropdown";
import FormTextField from "../../../components/form/FormTextField";
import ModalField from "../../../components/modal/ModalField";
import ModalGroup from "../../../components/modal/ModalGroup";
import ModalMasterDetailView from "../../../components/modal/ModalMasterDetailView";
import ModalRow from "../../../components/modal/ModalRow";
import { withModalSizeContext } from "../../../components/modal/ModalSizeContext";
import Dimensions from "../../../constants/styles/dimensions";
import { calendarOperations } from "../../../modules/definition/calendar";
import { PropTypeShapes } from "../../../types";
import CalendarSettingsWeekdayDetailView from "./CalendarSettingsWeekdayDetailView";

const CalendarSettingsWeekdayTab = props => {
  const items = props.listItems(props.weekdays).map(weekday => ({ ...weekday, canDelete: props.weekdays.count() > 1 }));

  const minHeight = props.maxHeight - Dimensions.MODAL_MASTER_DETAIL_TOP_MARGIN;

  return (
    <div className="weekdayTabWrapper" style={{ minHeight: `${minHeight}px` }}>
      <ModalGroup>
        <ModalRow className="weekdayHours">
          <ModalField label="Hours In Day">
            <FormTextField
              value={props.hoursInDay}
              numeric={true}
              isInteger={true}
              autoFocusOnEmpty={true}
              onChange={h => props.onHoursChange(h)}
              min={1}
              disabled={!props.canEditDateData}
            />
          </ModalField>
          <ModalField label="First Weekday of Final Era">
            <FormDropdown
              options={props.listItems(props.weekdays)}
              value={props.weekdayIndexAtZero}
              onChange={i => props.onSetWeekdayIndexAtZero(i)}
              disabled={!props.canEditDateData}
            />
          </ModalField>
        </ModalRow>
      </ModalGroup>
      <ModalMasterDetailView
        items={items}
        onAddClick={props.canEditDateData ? props.onAddWeekday : null}
        onDeleteClick={props.canEditDateData ? props.onRemoveWeekday : null}
        canEditDateData={props.canEditDateData}
        allowDrag={props.canEditDateData}
        onMoveItemAtIndex={props.onMoveWeekday}
        backText="Weekdays"
        disableMinHeight={true}
        itemsUseIndexAsId={true}
        //#!if iOS === true
// onDoneClick={props.onDoneClick}
        //#!endif
      >
        <CalendarSettingsWeekdayDetailView {...props} />
      </ModalMasterDetailView>
    </div>
  );
};

CalendarSettingsWeekdayTab.propTypes = {
  localStore: PropTypes.object,
  weekdays: ImmutablePropTypes.listOf(PropTypeShapes.weekday).isRequired,
  hoursInDay: PropTypes.number,
  weekdayIndexAtZero: PropTypes.number.isRequired,
  dispatchLocal: PropTypes.func.isRequired,
  onAddWeekday: PropTypes.func.isRequired,
  onMoveWeekday: PropTypes.func.isRequired,
  onRemoveWeekday: PropTypes.func.isRequired,
  onWeekdayNameChange: PropTypes.func.isRequired,
  onWeekdayShortNameChange: PropTypes.func.isRequired,
  onHoursChange: PropTypes.func.isRequired,
  onSetWeekdayIndexAtZero: PropTypes.func.isRequired,
  listItems: PropTypes.func.isRequired,
  canEditDateData: PropTypes.bool.isRequired,
  //#!if iOS === true
// onDoneClick: PropTypes.func.isRequired,
  //#!endif

  // From ModalSizeContext
  maxHeight: PropTypes.number.isRequired
};

const mapDispatchToProps = (_dispatch, props) => {
  // Note: We are always using dispatchLocal here so that the action only travels
  // back to the Settings Modal.
  // Changes are committed to the root store only when the dialog is confirmed.
  return {
    onAddWeekday: index => {
      props.dispatchLocal(
        calendarOperations.addWeekdayAtIndex(_.isNil(index) || index < 0 ? props.weekdays.size : index + 1)
      );
    },
    onMoveWeekday: (fromIndex, toIndex) => {
      props.dispatchLocal(calendarOperations.moveWeekday(fromIndex, toIndex));
    },
    onRemoveWeekday: index => {
      props.dispatchLocal(calendarOperations.deleteWeekdayAtIndex(index));
    },
    onWeekdayNameChange: (index, name) => {
      props.dispatchLocal(calendarOperations.editWeekdayName(index, name));
    },
    onWeekdayShortNameChange: (index, name) => {
      props.dispatchLocal(calendarOperations.editWeekdayShortName(index, name));
    },
    onSetWeekdayIndexAtZero: index => {
      props.dispatchLocal(calendarOperations.editWeekdayIndexAtZero(index));
    },
    onHoursChange: hours => {
      props.dispatchLocal(calendarOperations.editHoursInDay(hours));
    }
  };
};

export default withModalSizeContext(connect(null, mapDispatchToProps)(CalendarSettingsWeekdayTab));
